import { useSelector } from 'react-redux'
import { DEFAULT_CODE } from '../../layout/header/search/constants'
import { selectOtherCountry } from '../../layout/header/search/store/slice'
import useGetLocation from './useGetLocation'

const useSearchLocations = ({ disableCallApi = true }) => {
  const otherCountry = useSelector(selectOtherCountry)
  const { locations: vietNamLocations } = useGetLocation({
    disableCallApi,
  })
  const vietnam =
    vietNamLocations.find((item) => item.code === DEFAULT_CODE) ?? {}

  return [
    { ...vietnam, value: vietnam.value, label: vietnam.name },
    ...otherCountry,
  ]
}

export default useSearchLocations
